import React from "react";
import { useLocation } from "react-router-dom";
import { selectPropertyFromLocationHash } from "../../components/navigation/URL";
import { CompanyContext } from "../../reducers/company";
import { useProfile } from "../../reducers/profile";

export default function CompanySelectInit(props: {
  children: React.ReactNode;
}): React.ReactElement {
  const location = useLocation();
  const profile = useProfile();

  const [init, setInit] = React.useState(false);
  const { state, dispatch } = React.useContext(CompanyContext);

  React.useEffect(() => {
    const company_id = selectPropertyFromLocationHash("company", location.hash);
    if (company_id) {
      dispatch({ type: "SELECT_COMPANY_BY_ID", payload: company_id });
    } else {
      if (
        state.companies &&
        profile?.user_type !== "superadmin" &&
        state.companies.length >= 1
      ) {
        dispatch({ type: "SELECT_COMPANY", payload: state.companies[0] });
      }
    }
    setInit(true);
    // Re-runs whenever the URL hash, profile, or company list changes —
    // i.e. on inbound navigation and after any refetch of the company list.
    // The non-superadmin branch can re-select companies[0] on refetch; in
    // practice non-superadmins only have access to one company so this is a
    // no-op, but worth knowing if usage patterns change.
  }, [dispatch, location.hash, profile, state.companies]);

  return <>{init && props.children}</>;
}
